import { LMSMail } from 'src/@types/lms/mail';
import API from '../api';
import { APPICONFIG } from '../apiconfig';

class APIMAIL extends API {
  async getMailbox(id: string, box: string): Promise<any> {
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.REVIEWCOMMENTS.MAILBOX;
    this.data = { assignmentId: id };
    let dataResponse = await this.makePostRequest();
    const data = [];
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      if (box === 'inbox') {
        for (let i = 0; i < dataResponse.data.receivedEmails.length; i++) {
          data.push({
            id: dataResponse.data.receivedEmails[i].id,
            createdAt: dataResponse.data.receivedEmails[i].insertionDate,
            folder: 'inbox',
            from: {
              name: dataResponse.data.receivedEmails[i].userFullName,
              email: '',
              avatar: dataResponse.data.receivedEmails[i].userImage,
            },
            to: [
              {
                name: '',
                email: '',
                avatar: '',
              },
            ],
            message: dataResponse.data.receivedEmails[i].comment,
            subject: dataResponse.data.receivedEmails[i].subject,
            files: [],
            labelIds: [''], //dataResponse.data.recipients.groupName[0],
          });
          for (let j = 0; j < dataResponse.data.receivedEmails[i].recipients.length; j++) {
            if (
              data[i].labelIds.indexOf(
                dataResponse.data.receivedEmails[i].recipients[j].groupName
              ) === -1
            ) {
              data[i].labelIds.push(
                dataResponse.data.receivedEmails[i].recipients[j].groupName.toLowerCase()
              );
            }
            if (
              data[i].to
                .map(function (e: any) {
                  return e.name;
                })
                .indexOf(dataResponse.data.receivedEmails[i].recipients[j].groupName) === -1
            ) {
              data[i].to.push({
                name:
                  j > 0
                    ? ', ' + dataResponse.data.receivedEmails[i].recipients[j].groupName
                    : dataResponse.data.receivedEmails[i].recipients[j].groupName,
                email: '',
                avatar: '',
              });
            }
          }
          data[i].labelIds.splice(0, 1);
          data[i].to.splice(0, 1);
        }
      } else if (box === 'sent') {
        for (let i = 0; i < dataResponse.data.sentEmails.length; i++) {
          data.push({
            id: dataResponse.data.sentEmails[i].id,
            createdAt: dataResponse.data.sentEmails[i].insertionDate,
            folder: 'sent',
            from: {
              name: dataResponse.data.sentEmails[i].userFullName,
              email: '',
              avatar: dataResponse.data.sentEmails[i].userImage,
            },
            to: [
              {
                name: '',
                email: '',
                avatar: '',
              },
            ],
            message: dataResponse.data.sentEmails[i].comment,
            subject: dataResponse.data.sentEmails[i].subject,
            files: [],
            labelIds: ['coordinator'],
          });
          for (let j = 0; j < dataResponse.data.sentEmails[i].recipients.length; j++) {
            if (
              data[i].labelIds.indexOf(dataResponse.data.sentEmails[i].recipients[j].groupName) ===
              -1
            ) {
              data[i].labelIds.push(
                dataResponse.data.sentEmails[i].recipients[j].groupName.toLowerCase()
              );
            }
            if (
              data[i].to
                .map(function (e: any) {
                  return e.name;
                })
                .indexOf(dataResponse.data.sentEmails[i].recipients[j].groupName) === -1
            ) {
              data[i].to.push({
                name:
                  j > 0
                    ? ', ' + dataResponse.data.sentEmails[i].recipients[j].groupName
                    : dataResponse.data.sentEmails[i].recipients[j].groupName,
                email: '',
                avatar: '',
              });
            }
          }
          data[i].labelIds.splice(0, 1);
          data[i].to.splice(0, 1);
        }
      } else if (box === 'coordinator') {
        let dataindex = 0;
        for (let i = 0; i < dataResponse.data.receivedEmails.length; i++) {
          if (
            dataResponse.data.receivedEmails[i].recipients
              .map(function (e: any) {
                return e.groupName;
              })
              .indexOf('Coordinator') !== -1
          ) {
            data.push({
              id: dataResponse.data.receivedEmails[i].id,
              createdAt: dataResponse.data.receivedEmails[i].insertionDate,
              folder: 'inbox',
              from: {
                name: dataResponse.data.receivedEmails[i].userFullName,
                email: '',
                avatar: dataResponse.data.receivedEmails[i].userImage,
              },
              to: [
                {
                  name: '',
                  email: '',
                  avatar: '',
                },
              ],
              message: dataResponse.data.receivedEmails[i].comment,
              subject: dataResponse.data.receivedEmails[i].subject,
              files: [],
              labelIds: [''], //dataResponse.data.recipients.groupName[0],
            });
            for (let j = 0; j < dataResponse.data.receivedEmails[i].recipients.length; j++) {
              if (
                data[dataindex].labelIds.indexOf(
                  dataResponse.data.receivedEmails[i].recipients[j].groupName
                ) === -1
              ) {
                data[dataindex].labelIds.push(
                  dataResponse.data.receivedEmails[i].recipients[j].groupName.toLowerCase()
                );
              }
              if (
                data[dataindex].to
                  .map(function (e: any) {
                    return e.name;
                  })
                  .indexOf(dataResponse.data.receivedEmails[i].recipients[j].groupName) === -1
              ) {
                data[dataindex].to.push({
                  name:
                    j > 0
                      ? ', ' + dataResponse.data.receivedEmails[i].recipients[j].groupName
                      : dataResponse.data.receivedEmails[i].recipients[j].groupName,
                  email: '',
                  avatar: '',
                });
              }
            }
            data[dataindex].labelIds.splice(0, 1);
            data[dataindex].to.splice(0, 1);
            dataindex++;
          }
        }
      } else if (box === 'client') {
        let dataindex = 0;
        for (let i = 0; i < dataResponse.data.receivedEmails.length; i++) {
          if (
            dataResponse.data.receivedEmails[i].recipients
              .map(function (e: any) {
                return e.groupName;
              })
              .indexOf('Client') !== -1
          ) {
            data.push({
              id: dataResponse.data.receivedEmails[i].id,
              createdAt: dataResponse.data.receivedEmails[i].insertionDate,
              folder: 'inbox',
              from: {
                name: dataResponse.data.receivedEmails[i].userFullName,
                email: '',
                avatar: dataResponse.data.receivedEmails[i].userImage,
              },
              to: [
                {
                  name: '',
                  email: '',
                  avatar: '',
                },
              ],
              message: dataResponse.data.receivedEmails[i].comment,
              subject: dataResponse.data.receivedEmails[i].subject,
              files: [],
              labelIds: [''],
            });
            for (let j = 0; j < dataResponse.data.receivedEmails[i].recipients.length; j++) {
              if (
                data[dataindex].labelIds.indexOf(
                  dataResponse.data.receivedEmails[i].recipients[j].groupName
                ) === -1
              ) {
                data[dataindex].labelIds.push(
                  dataResponse.data.receivedEmails[i].recipients[j].groupName.toLowerCase()
                );
              }
              if (
                data[dataindex].to
                  .map(function (e: any) {
                    return e.name;
                  })
                  .indexOf(dataResponse.data.receivedEmails[i].recipients[j].groupName) === -1
              ) {
                data[dataindex].to.push({
                  name:
                    j > 0
                      ? ', ' + dataResponse.data.receivedEmails[i].recipients[j].groupName
                      : dataResponse.data.receivedEmails[i].recipients[j].groupName,
                  email: '',
                  avatar: '',
                });
              }
            }
            data[dataindex].labelIds.splice(0, 1);
            data[dataindex].to.splice(0, 1);
            dataindex++;
          }
        }
      } else if (box === 'country') {
        let dataindex = 0;
        for (let i = 0; i < dataResponse.data.receivedEmails.length; i++) {
          if (
            dataResponse.data.receivedEmails[i].recipients
              .map(function (e: any) {
                return e.groupName;
              })
              .indexOf('Country') !== -1
          ) {
            data.push({
              id: dataResponse.data.receivedEmails[i].id,
              createdAt: dataResponse.data.receivedEmails[i].insertionDate,
              folder: 'inbox',
              from: {
                name: dataResponse.data.receivedEmails[i].userFullName,
                email: '',
                avatar: dataResponse.data.receivedEmails[i].userImage,
              },
              to: [
                {
                  name: '',
                  email: '',
                  avatar: '',
                },
              ],
              message: dataResponse.data.receivedEmails[i].comment,
              subject: dataResponse.data.receivedEmails[i].subject,
              files: [],
              labelIds: [''],
            });
            for (let j = 0; j < dataResponse.data.receivedEmails[i].recipients.length; j++) {
              if (
                data[dataindex].labelIds.indexOf(
                  dataResponse.data.receivedEmails[i].recipients[j].groupName
                ) === -1
              ) {
                data[dataindex].labelIds.push(
                  dataResponse.data.receivedEmails[i].recipients[j].groupName.toLowerCase()
                );
              }
              if (
                data[dataindex].to
                  .map(function (e: any) {
                    return e.name;
                  })
                  .indexOf(dataResponse.data.receivedEmails[i].recipients[j].groupName) === -1
              ) {
                data[dataindex].to.push({
                  name:
                    j > 0
                      ? ', ' + dataResponse.data.receivedEmails[i].recipients[j].groupName
                      : dataResponse.data.receivedEmails[i].recipients[j].groupName,
                  email: '',
                  avatar: '',
                });
              }
            }
            data[dataindex].labelIds.splice(0, 1);
            data[dataindex].to.splice(0, 1);
            dataindex++;
          }
        }
      }
    }
    const bigData = 
    {
      labelData: {
        inbox: dataResponse.data.receivedEmails.length,
        sent: dataResponse.data.sentEmails.length
      },
      mailData: data
    }
    return bigData;
  }

  async getMailDetails(id: string): Promise<any> {
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.REVIEWCOMMENTS.DETAILS.replace('{id}', id);
    this.data = null;
    let response = {};
    let dataResponse = await this.makeGetRequest();
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      response = {
        id: id,
        createdAt: dataResponse.data.insertionDate,
        folder: '',
        files: [],
        from: {
          name: dataResponse.data.userFullName,
          email: '',
          avatar: dataResponse.data.userImage,
        },
        to: [
          {
            name: 'Coordinator', //dataResponse.data.recipients.groupName[0],
            email: 'Coordinator', //dataResponse.data.recipients.groupName[0],
            avatar: '',
          },
        ],
        labelIds: ['coordinator'], //dataResponse.data.recipients.groupName[0],
        message: dataResponse.data.comment,
        subject: dataResponse.data.subject,
      };
    }
    return response;
  }

  async sendMail(data: LMSMail): Promise<any> {
    let response = {
      success: false,
      errorMessage: '',
    };
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.REVIEWCOMMENTS.CREATE;
    this.data = data;
    let dataResponse = await this.makePostRequest();
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      response.success = true;
    } else {
      response.success = false;
      response.errorMessage = dataResponse.messages ? dataResponse.messages[0] : dataResponse.exception ? dataResponse.exception : "Unexpected error (" + dataResponse.status + ")";
    }
    return response;
  }

  async deleteMail(id: string): Promise<any> {
    // let response = {
    //   success: false,
    //   errorMessage: '',
    // };
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.REVIEWCOMMENTS.DELETE.replace('{id}', id);
    this.data = null;
    let dataResponse = await this.makeDeleteRequest();
    return dataResponse;
  }

  async getRecipients(id: string): Promise<any> {
    this.url =
      APPICONFIG.API_URL + APPICONFIG.API_PATHS.REVIEWCOMMENTS.RECIPIENTS + '?assignmentId=' + id;
    this.data = null;
    let dataResponse = await this.makePostRequest();
    let data = [];
    let countries: string[] = [];
    let countriesRecipients: string[] = [];
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      if (dataResponse.data.countries) {
        for (let i = 0; i < dataResponse.data.countries.length; i++) {
          if (
            countries.indexOf(dataResponse.data.countries[i].groupName) === -1 &&
            dataResponse.data.countries[i].recipientId !== null
          ) {
            countries.push(dataResponse.data.countries[i].groupName);
            countriesRecipients.push(dataResponse.data.countries[i].recipientId);
          }
        }
      }
      if (dataResponse.data.coordinators) {
        if (dataResponse.data.coordinators.length > 0) {
          data.push(
            { value: 0, label: 'Available Roles:', isDivider: true },
            { value: 1, recipientId: dataResponse.data.coordinators[0].recipientId, label: 'Coordinator' }
          );
        }
      }
      if (dataResponse.data.clients) {
        if (dataResponse.data.clients.length > 0) {
          if (data.length === 0) {
            data.push({ value: 0, label: 'Available Roles:', isDivider: true });
          }
          data.push({ value: 2, recipientId: dataResponse.data.clients[0].recipientId, label: 'Client' });
        }
      }
      if (countries.length > 0) {
        data.push({ value: 3, label: 'Available Resources:', isDivider: true });
        for (let i = 0; i < countries.length; i++) {
          data.push({ value: i + 3, recipientId: countriesRecipients[i], label: countries[i] });
        }
      }
    }
    return data;
  }
}

export default APIMAIL;
